export const IS_LOADING_MEMBER_INVITE = 'IS_LOADING_MEMBER_INVITE';
export const SET_INVITE_ALERT = 'SET_INVITE_ALERT';
export const REMOVE_INVITE_ALERT = 'REMOVE_INVITE_ALERT';
